import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const CustomerAuthContext = createContext(null);
const KEY = "umg_customer_token";

export const CustomerAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) { setLoading(false); return; }
    api.get("/account/me").then((r) => setUser(r.data)).catch(() => setUser(false)).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/account/login", { email, password });
    if (data.token) localStorage.setItem(KEY, data.token);
    setUser(data); return data;
  };
  const register = async (name, email, password) => {
    const { data } = await api.post("/account/register", { name, email, password });
    if (data.token) localStorage.setItem(KEY, data.token);
    setUser(data); return data;
  };
  const logout = async () => {
    try { await api.post("/account/logout"); } catch (e) {}
    localStorage.removeItem(KEY); setUser(false);
  };

  return (
    <CustomerAuthContext.Provider value={{ user, login, register, logout, loading }}>
      {children}
    </CustomerAuthContext.Provider>
  );
};

export const useCustomerAuth = () => useContext(CustomerAuthContext);
